import { useAlertService } from '@/shared/lib/useAlertService'
import { useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { UseCoParentSelectionResult, ParentSearchResult } from '../coparent-page/type'
import { CoParentsService } from '@/shared/api/rest/services/co-parents.service'

export function useCoParentSelection(): UseCoParentSelectionResult {
    const [selectedCoParent, setSelectedCoParent] = useState<ParentSearchResult | null>(
        null
    )
    const [isAdding, setIsAdding] = useState(false)
    const alertService = useAlertService()
    const queryClient = useQueryClient()

    const selectCoParent = (coParent: ParentSearchResult) => {
        setSelectedCoParent(coParent)
    }

    const addCoParent = async (_parentId: string) => {
        if (!selectedCoParent) {
            alertService.error('No co-parent selected')
            return
        }

        setIsAdding(true)
        try {
            await CoParentsService.linkExisting(selectedCoParent._id)
            alertService.success('Co-parent added successfully')
            queryClient.invalidateQueries({ queryKey: ['co-parent'] })
        } catch (error) {
            alertService.error(
                error instanceof Error ? error.message : 'Co-Parent Addition Failed',
                'Co-Parent Addition Failed'
            )
        } finally {
            setIsAdding(false)
        }
    }

    const clearSelection = () => {
        setSelectedCoParent(null)
    }

    return {
        selectedCoParent,
        selectCoParent,
        addCoParent,
        isAdding,
        clearSelection
    }
}
